import _app from '@core/modules/theme/pages/_app';

// /**
//  * Import global css
//  * */
import '../core/styles/index.css';
import '../core/styles/mediaquery.css';
import '../core/styles/flexboxgrid.min.css';
import '../core/styles/checkboxtree.css';
import 'rc-calendar/assets/index.css';
import 'rc-time-picker/assets/index.css';

export default _app;
